import { useEffect, useState } from 'react';
import { Box } from '@mui/material';
import { EVENTO_QUENTE_MUDOU, quenteAgoraService } from '../quenteAgoraService';

// O contador do menu (Prospecção → "Quente agora"): itens abertos meus e sem dono. Relê a cada
// minuto com a aba visível, quando a janela volta ao foco e quando a tela da fila avisa que mudou.
// Falha é silêncio: quem não tem acesso ao CRM simplesmente não vê número.

const INTERVALO_MS = 60_000;

/** Total da fila "minhas" (as minhas + as sem dono). Usado pelo menu e pelo atalho do celular. */
export const useTotalQuente = (): number => {
  const [n, setN] = useState(0);
  useEffect(() => {
    let vivo = true;
    const atualizar = () => {
      if (typeof document !== 'undefined' && document.visibilityState === 'hidden') return;
      quenteAgoraService
        .listar({ escopo: 'MINHAS' })
        .then((l) => vivo && setN(l.total))
        .catch(() => vivo && setN(0));
    };
    atualizar();
    const t = window.setInterval(atualizar, INTERVALO_MS);
    window.addEventListener('focus', atualizar);
    window.addEventListener(EVENTO_QUENTE_MUDOU, atualizar);
    return () => {
      vivo = false;
      window.clearInterval(t);
      window.removeEventListener('focus', atualizar);
      window.removeEventListener(EVENTO_QUENTE_MUDOU, atualizar);
    };
  }, []);
  return n;
};

export const ContadorQuente = () => {
  const n = useTotalQuente();
  if (n <= 0) return null;
  return (
    <Box
      component="span"
      aria-label={`${n} na fila quente`}
      sx={{
        ml: 1,
        minWidth: 20,
        height: 20,
        px: 0.75,
        borderRadius: 10,
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: 11,
        fontWeight: 600,
        bgcolor: 'error.main',
        color: 'error.contrastText',
        flexShrink: 0
      }}
    >
      {n > 99 ? '99+' : n}
    </Box>
  );
};

export default ContadorQuente;
